import { axiosInstance } from "../services/axiosInstance";
import catchAsync from "../utils/catchAsync";

export const addPriceList = catchAsync(async (body) => {
  const { data } = await axiosInstance.post(
    '/api/resource/Price List',
    body
  );
  return data;
});
export const updatePriceList = catchAsync(async (body, id) => {
  const { data } = await axiosInstance.put(
    `/api/resource/Price List/${id}`,
    body
  );
  return data;
});

export const getPriceList = catchAsync(async ({key="",value=""}) => {
  let baseUrl =  '/api/resource/Price List?fields=["price_list_name","name","enabled","currency","buying","selling"]&limit_start=0&limit_page_length=0'
  if(value){
    baseUrl += `&filters=[["${key}","like","%${value}%"]]`;
  }
  const { data } = await axiosInstance.get(
    baseUrl
  );
  // const { data } = await axiosInstance.get(
  // );
  return data;
});
export const deletePriceList = catchAsync(async (record) => {
  const { data } = await axiosInstance.delete(
    `/api/resource/Price List/${record}`
  );
  return data;
});
export const getPriceListDetails = catchAsync(async (id) => {
  const { data } = await axiosInstance.get(
    `/api/resource/Price List/${id}`
  );
  return data;
});